/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



jQuery(function($) {
  
  /* CHANGE ANNOUNCEMENT TEXT AFTER EVERY 6s */
  var announcementText = $(".AnnouncementBar__Wrapper .AnnouncementBar__Content");
  var textIndex = -1;
  function showNextText() {
    ++textIndex;
    announcementText.eq(textIndex % announcementText.length)
    .fadeIn(2000)
    .delay(2000)
    .fadeOut(2000, showNextText);
  }
  showNextText();
  /* /CHANGE ANNOUNCEMENT TEXT AFTER EVERY 6s */
  
  
  /* SHOW NEWSLETTER POPUP ON ICON CLICK */
  $('.Header__Icon--clickableNewsletter').on('click', function() {
    var newsletterVisible = $("#Newsletter").attr("aria-hidden");
    toggleNewsletter(newsletterVisible);
  });
  
  $('#Newsletter .NewsletterPopup__Close').on('click', function() {
    $("body").removeClass("show--newsletterPopup");
    $("#Newsletter").attr("aria-hidden", "true");
  });
  /* SHOW NEWSLETTER POPUP ON ICON CLICK */
  
  
  /* SEE MORE SECTION */
  $('.see-more-btn').on('click', function() {
    const element = $(this).closest('.Section--SeeMore').find('.SeeMore__Content');

    let lessText = $(this).attr('data-less-text');
    if(!lessText) {
      lessText = '- Read Less';
    }

    let moreText = $(this).attr('data-more-text');
    if(!moreText) {
      moreText = '- Read More';
    }

    if(element.hasClass('show')) {
      element.removeClass('show');
      $(this).text(moreText);
    } else {
      element.addClass('show');
      $(this).text(lessText);
    }
  });
  /* /SEE MORE SECTION */
  
  
  /* SHOW/HIDE FOOTER MENU LINKS IN MOBILE */
  const windowWidth = $(window).width();
  $('.Footer__Block--links .Footer__Title').on('click', function() {
    if(windowWidth < 641) {
      $(this).parent().toggleClass('show--Linklist');
    }
  });
  /* /SHOW/HIDE FOOTER MENU LINKS IN MOBILE */
  
  
  /* VIDEO POPUP */
  $('.video-popup').on("click", function() {
    $(this).parent().toggleClass("video-cover-active");
  });
  /* /VIDEO POPUP */
  
  
  /* OPEN SIDEBAR CART ON ADDING PRODUCT */
  $(".ProductForm__AddToCart--custom").on("click", function(event) {
    event.preventDefault();
    var ID = $(this).attr("data-id");
    addItemToCart(ID, 1);
  });
  /* /OPEN SIDEBAR CART ON ADDING PRODUCT */
  
  $(".Drawer__Close--custom").on("click", function(event) {
    event.preventDefault();
    console.log("close sidebar");
    $(".Drawer__Close").removeClass('Drawer__Close--custom');
    closeSidebar();
  });
  
  $(".Drawer__Close").on("click", function(event) {
    if (!$("body").hasClass("template-product")) {
    	closeSidebar();
    }
  });
  
  /* CLOSE SIDEBAR MENU ON MENU LINK CLICK */
  $(".SidebarMenu .Link").on("click", function() {
    $(".Drawer__Close[data-drawer-id='sidebar-menu']").trigger("click");
  });
  /* /CLOSE SIDEBAR MENU ON MENU LINK CLICK */
  
});


function toggleNewsletter(newsletterVisible) {
  if(newsletterVisible == "true") {
    $("body").addClass("show--newsletterPopup");
    $("#Newsletter").attr("aria-hidden", "false");
  } else {
    $("#Newsletter").attr("aria-hidden", "true");
  }
}

function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
      openSidebar();
    }   
  }); 
}


function openSidebar() {
  $('.PageOverlay').addClass('is-visible');
  $('#sidebar-cart').attr('aria-hidden', 'false');
  $('#sidebar-cart').attr('tabindex', '-1');
}

function closeSidebar() {
  $('.PageOverlay').removeClass('is-visible');
  $('#sidebar-cart').attr('aria-hidden', 'true');
  $('#sidebar-cart').removeAttr('tabindex');
}